import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Sync} from '../../client/sync'
import {Dialog} from '../common/base/dialog/dialog'
import {pendingCompanyUserStore} from './pending-company-user-store'

export const TwContent = tw.div`
  text-left
  text-secondary
  text-sm-regular
  leading-5
  cursor-default
`

let prevModified = -1
const loginCancelKeysPrefix = 'login_cancel_key'

export const PendingCompanyDialog = observer(() => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const currentModified = pendingCompanyUserStore.state.modified

    let pendingCompanies = Sync.pendingCompanies || []
    for (const companyId of pendingCompanies) {
      const key = loginCancelKeysPrefix + companyId
      const cancelled = localStorage.getItem(key)
      if (cancelled) {
        pendingCompanies = pendingCompanies.filter(id => id !== companyId)
      }
    }

    if (prevModified !== currentModified && pendingCompanies?.length > 0) {
      setShow(true)
      prevModified = currentModified
    }
  }, [Sync.pendingCompanies, pendingCompanyUserStore.state.modified])

  if (!show) {
    return null
  }

  const close = () => {
    setShow(false)
    for (const companyId of Sync.pendingCompanies ?? []) {
      const key = loginCancelKeysPrefix + companyId
      localStorage.setItem(key, '1')
    }
  }

  const companyTitles = Sync.getPendingCompanies()
    .map(c => c.companyName)
    .filter(t => !!t)
    .join(', ')

  return (
    <Dialog
      close={close}
      submit={close}
      title={Lang.msg.users.waitConfirmAdmin}
      width={488}
      primaryBtnText={Lang.msg.users.buttonTextDialog}
      popupInWnd
      noScroll={false}
      type="one-button"
    >
      <TwContent>{Lang.msg.users.requestSentToAdmin2(companyTitles)}</TwContent>
    </Dialog>
  )
})
